module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-swop bg-light"
  }, [_c('div', {
    staticClass: "bg-white h-24 border-b border-solid border-gray-300 flex items-center"
  }, [_c('div', {
    staticClass: "container p-8 mx-auto"
  }, [_c('div', {
    staticClass: "md:flex md:items-center md:justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-4 flex md:mt-0 md:ml-4"
  }, [(_vm.step > 1) ? _c('button', {
    staticClass: "mr-4 inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_vm._v("\n                        Gå tilbage\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.step < 3) ? _c('button', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step + 1
      }
    }
  }, [_vm._v("\n                        Næste\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('button', {
    staticClass: "bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateAlert = true
      }
    }
  }, [_vm._v("\n                        Opret SWOP\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.showCreateAlert) ? _c('custom-alert', {
    attrs: {
      "heading": "Er oplysningerne korrekte?",
      "description": 'Serienummer<br><b>' + _vm.selection.serial + '</b><br><br>Beholder<br><b>' + _vm.selection.container.name + '</b><br><br>Medarbejder<br><b>' + _vm.selection.worker.name + '</b>',
      "acceptText": "Opret SWOP",
      "cancelText": "Annullér"
    },
    on: {
      "cancel": function($event) {
        _vm.showCreateAlert = false
      },
      "accept": function($event) {
        return _vm.createSwop()
      }
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content overflow-y-auto",
    staticStyle: {
      "min-height": "calc(100vh - 10rem)",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "container p-8 mx-auto bg-light"
  }, [(_vm.step === 1) ? _c('div', {
    staticClass: "first-step"
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "w-1/3"
  }, [_c('div', {
    staticClass: "max-w-xs rounded-md shadow-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection.serial),
      expression: "selection.serial"
    }],
    staticClass: "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
    attrs: {
      "id": "serial",
      "placeholder": "fx VCF352XXX ...",
      "autocapitalize": "characters"
    },
    domProps: {
      "value": (_vm.selection.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selection, "serial", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "second-step"
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-6"
  }, [_vm._v("\n                    2. Vælg beholder\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "containers flex flex-wrap -mx-4"
  }, _vm._l((_vm.containers), function(container) {
    return _c('div', {
      key: container.name,
      staticClass: "w-1/3 px-4 mb-4"
    }, [_c('div', {
      staticClass: "flex items-center justify-between single-container bg-white shadow p-4 rounded",
      class: {
        'selected': _vm.selection.container.id === container.id
      },
      on: {
        "click": function($event) {
          _vm.selection.container = container
        }
      }
    }, [_c('div', [_vm._v("\n                                " + _vm._s(container.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-500"
    }, [_vm._v("\n                                " + _vm._s(container.number) + "\n                            ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "third-step"
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-6"
  }, [_vm._v("\n                    3. Vælg medarbejder\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "workers flex flex-wrap -mx-4"
  }, _vm._l((_vm.workers), function(worker) {
    return _c('div', {
      key: worker.name,
      staticClass: "w-1/3 px-4 mb-4"
    }, [_c('div', {
      staticClass: "flex items-center justify-between single-worker bg-white shadow p-4 rounded",
      class: {
        'selected': _vm.selection.worker.id === worker.id
      },
      on: {
        "click": function($event) {
          _vm.selection.worker = worker
        }
      }
    }, [_c('span', [_vm._v(_vm._s(worker.name))]), _vm._v(" "), (worker.color) ? _c('div', {
      staticClass: "inline-block h-4 w-4 rounded-full mr-2",
      style: ('background:' + worker.color)
    }) : _c('div', {
      staticClass: "inline-block h-4 w-4 rounded-full bg-main mr-2"
    })])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1 min-w-0"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate"
  }, [_vm._v("\n                        Opret SWOP\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-1/3"
  }, [_c('div', {
    staticClass: "text-xl font-medium mb-6"
  }, [_vm._v("\n                            1. Indtast serienummer\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd77c80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/createSwop.vue
// module id = 296
// module chunks = 1